module.exports = __webpack_public_path__ + "img/41.8bd95140.jpg";